<div
	class="jepto-analysis-card__outer-wrapper"
	[attr.data-testid]="effectiveTestId()"
	[class.card--selected]="isSelected()"
	(click)="onCardClick()"
>
	@if (isDebugMode()) {
		<div class="jepto-analysis-card__debug">
			<span class="jepto-analysis-card__debug-id">{{ cardId() }}</span>
			<span class="jepto-analysis-card__debug-type">analysis</span>
		</div>
	}

	@if (effectiveLoading()) {
		<div class="jepto-analysis-card__loader">
			<jepto-ui-progress-bar-indeterminate />
		</div>
	}

	<div class="card-content jepto-analysis-card__content">
		@if (effectiveTitle() || effectiveSubtitle() || effectiveIcon()) {
			<div class="card-header">
				<div class="card-icon-title-wrapper">
					@if (effectiveIcon()) {
						<mat-icon class="material-symbols-outlined card-icon">{{
							effectiveIcon()
						}}</mat-icon>
					}
					@if (effectiveTitle()) {
						<h2 class="card-title">{{ effectiveTitle() }}</h2>
					}
				</div>
				@if (effectiveSubtitle()) {
					<div class="card-subtitle">{{ effectiveSubtitle() }}</div>
				}
			</div>
		}

		@if (activePeriod()) {
			@if (activePeriodHeadline()) {
				<p
					class="jepto-analysis-card__headline"
					[class.jepto-analysis-card__headline--fade-out]="
						fadeOutHeadline()
					"
					[class.jepto-analysis-card__headline--fade-in]="
						fadeInHeadline()
					"
				>
					{{ activePeriodHeadline() }}
				</p>
			}
		} @else if (!effectiveLoading() && !hasContent()) {
			<p class="jepto-analysis-card__empty">{{ emptyMessage() }}</p>
		}

		@if (hasContent() || displayPeriods().length > 1) {
			<div class="jepto-analysis-card__footer">
				@if (displayPeriods().length > 1) {
					<div
						class="jepto-analysis-card__dots"
						role="tablist"
						aria-label="Analysis periods"
					>
						@for (
							period of displayPeriods();
							track periodKey(period);
							let i = $index
						) {
							<button
								type="button"
								role="tab"
								class="jepto-analysis-card__dot"
								[class.jepto-analysis-card__dot--active]="
									activePeriodIndex() === i
								"
								[attr.aria-label]="
									'Show analysis for ' +
									periodLabel(period, i)
								"
								[attr.aria-selected]="activePeriodIndex() === i"
								(click)="
									selectPeriod(periodKey(period));
									$event.stopPropagation()
								"
							></button>
						}
					</div>
				}

				@if (hasContent()) {
					<div class="jepto-analysis-card__actions">
						<button
							#openAnalysisBtn
							type="button"
							class="jepto-analysis-card__open-btn"
							[class.jepto-analysis-card__open-btn--static]="
								!openAnalysisInteractive()
							"
							[disabled]="effectiveLoading()"
							[attr.aria-disabled]="
								!openAnalysisInteractive() || effectiveLoading()
									? true
									: null
							"
							(click)="openDrawer(); $event.stopPropagation()"
						>
							Open full analysis
							<mat-icon
								class="material-symbols-outlined jepto-analysis-card__open-btn-icon"
								aria-hidden="true"
								>arrow_forward</mat-icon
							>
						</button>
					</div>
				}
			</div>
		}
	</div>

	@if (isSelected()) {
		<div class="card-action-buttons">
			<button
				type="button"
				class="card-action-btn"
				aria-label="Edit card"
				(click)="editCard.emit(); $event.stopPropagation()"
			>
				<span class="icon-edit-2"></span>
			</button>
			<button
				type="button"
				class="card-action-btn"
				aria-label="More options"
				[matMenuTriggerFor]="cardMenu"
				(click)="$event.stopPropagation()"
			>
				<span class="icon-more-vertical"></span>
			</button>
		</div>

		<mat-menu #cardMenu="matMenu" panelClass="card-actions-menu">
			<button mat-menu-item (click)="editCard.emit()">Edit</button>
			<button
				mat-menu-item
				class="card-menu-item--danger"
				(click)="deleteCard.emit()"
			>
				Delete
			</button>
		</mat-menu>
	}

	@if (drawerOpen()) {
		<jepto-analysis-drawer
			[testId]="effectiveTestId() + '-drawer'"
			[analyses]="displayPeriods()"
			[activePeriodId]="
				activePeriod() ? periodKey(activePeriod()!) : undefined
			"
			[isOpen]="true"
			[overlayMode]="drawerOverlay()"
			[overlayHost]="drawerOverlayHost()"
			[panelWidth]="drawerPanelWidth()"
			[triggerElement]="triggerElement"
			[themeMode]="activeThemeMode()"
			[themeConfig]="themeConfig()"
			[palette]="palette()"
			[cardStyle]="effectiveStyle()"
			(periodSelected)="selectPeriod($event)"
			(closed)="closeDrawer()"
		/>
	}
</div>
